function addExtraPriceProperty (categories) {
  const returnCategories = categories

  for (const category of returnCategories) {
    for (const product of category.products) {
      const activeIndex = getActiveIndex(category.products)
      if (activeIndex >= 0 && category.selector !== 'multiple') {
        product.extra_price =
          product.product_price - category.products[activeIndex].product_price
      } else {
        product.extra_price = product.product_price
      }
    }
  }

  for (const category of returnCategories) {
    for (const product of category.products) {
      if (product.extra_price_base === undefined) {
        const activeIndex = getActiveIndex(category.products)
        if (activeIndex >= 0 && category.selector === 'single') {
          product.extra_price_base =
            product.product_price - category.products[activeIndex].product_price
        } else if (category.selector === 'multiple' && product.active === 1) {
          product.extra_price_base = 0
        } else {
          product.extra_price_base = product.product_price
        }
      }
    }
  }

  return returnCategories
}

function getActiveIndex (products) {
  for (let index = 0; index < products.length; index++) {
    const product = products[index]

    if (product.active || product.active === 1) {
      return index
    }
  }
  return -1
}

export default {
  addExtraPriceProperty
}
